import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { badgeBackgroundColors } from '../../globals.js';
import styles from './badge.module.scss.js';

/**
 * @component Badge
 * @package Badges
 * @document ../_docs/code/Badge.editor.tsx
 * @document ../_docs/code/Badge.snippet.tsx
 * @document ../_docs/code/Badge.import.tsx
 */
const Badge = (_a) => {
    var { surface = 'lightPrimary', backgroundColor = 'red', numberOfLines = 1, maxWidth = 'auto', children, textColor, padding, borderRadius, id } = _a, rest = __rest(_a, ["surface", "backgroundColor", "numberOfLines", "maxWidth", "children", "textColor", "padding", "borderRadius", "id"]);
    const badgeStyles = [
        styles.badge,
        styles[backgroundColor.toLowerCase()],
        styles[surface.toLowerCase()],
        maxWidth && maxWidth !== 'auto' ? styles.maxWidth : '',
    ];
    const isTokenColor = badgeBackgroundColors.includes(backgroundColor) || false;
    return (jsx("div", Object.assign({}, rest, { id: id, className: badgeStyles.join(' '), style: {
            maxWidth,
            WebkitLineClamp: numberOfLines || undefined,
            backgroundColor: !isTokenColor ? backgroundColor : undefined,
            color: !isTokenColor ? textColor : undefined,
            padding: padding || undefined,
            borderRadius: borderRadius || undefined,
        }, children: children })));
};

export { Badge as default };
